import Footer from '@components/common/footer'
import Navbar from '@components/common/navbar'
import CurriculumDesign from '@components/curriculum/curriculum-design'
import FirstFold from '@components/curriculum/first-fold'
import Learning from '@components/curriculum/learning'
import Skills from '@components/curriculum/skills'
import StemAccrediated from '@components/curriculum/stem-accrediated'
import CompetitionsFold from '@components/home/competitions-fold'
import StudentProjectsFold from '@components/home/student-projects-fold'
import TestimonialsFold from '@components/landing-page/geo-landing-page/testimonials'
import useDetectCountry from '@hooks/useDetectCountry'
import { curriculumSeo } from '@lib/seo'
import { NextSeo } from 'next-seo'
import dynamic from 'next/dynamic'

const TabbedCurriculum = dynamic(() =>
  import('@components/home/tabbed-curriculum')
)
const PersonalizedCourse = dynamic(() =>
  import('@components/home/personalized-course-fold')
)
const SpecializedCourse = dynamic(() =>
  import('@components/home/specialized-course-fold')
)
const GroupClasses = dynamic(() => import('@components/home/group-classes'))

const CurriculumPage = () => {
  const { countryCode } = useDetectCountry()
  const isCountryUsOrCa = countryCode === 'US' || countryCode === 'CA'
  return (
    <>
      <NextSeo {...curriculumSeo} />
      <Navbar isSticky={true} />
      <FirstFold />
      <CurriculumDesign />
      {!isCountryUsOrCa && <TabbedCurriculum showCTA={true} />}
      <StemAccrediated />
      {isCountryUsOrCa ? (
        <>
          <PersonalizedCourse />
          <SpecializedCourse />
        </>
      ) : (
        <GroupClasses />
      )}
      <Skills />
      <CompetitionsFold />
      <Learning />
      <StudentProjectsFold />
      <TestimonialsFold shouldCtaScrollToTop={false} />
      <div className="mt-16">
        <Footer />
      </div>
    </>
  )
}

export async function getStaticProps() {
  return {
    props: {}, // will be passed to the page component as props
  }
}

export default CurriculumPage
